import { Space } from 'antd';
import React from 'react';

export const IconText = ({ icon, text }: { icon: any; text: string }) => (
  <Space>
    {text}
    {React.createElement(icon)}
  </Space>
);
